import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import "./styles/customers-styles.scss"
import CustomerTableTopBar from './includes/CustomerTable/CustomerTableTopBar'
import CustomerTable from './includes/CustomerTable/CustomerTable'
import { toast } from 'react-toastify';
import SectionLoading from 'utlis/helpers/SectionLoading/SectionLoading'
import Pagination from 'components/CommonComponents/Pagination'
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'
import useQuery from 'utlis/CustomHooks/useQueryHook'

import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_FETCHING_CUSTOMERS,
} from 'utlis/AppMessages/AppMessages'
import { getCustomers } from 'utlis/Apis/Customers_API'


function Customers(props) {
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const [customers, setCustomers] = useState([])
    const [loading, setLoading] = useState(true)

    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)

    const [column__Customer, setColumn__Customer] = useState(true)
    const [column__Email, setColumn__Email] = useState(true)
    const [column__Type, setColumn__Type] = useState(true)
    const [column__TwoFactors, setColumn__TwoFactors] = useState(true)
    const [column__LastActive, setColumn__LastActive] = useState(true)
    const [column__Status, setColumn__Status] = useState(true)
    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)
    const [paginationLinks, setPaginationLinks] = useState([])
    const [searchQuery, setSearchQuery] = useState("")

    let query = useQuery();
    let page = query.get('page')
    let keyword = query.get('keyword')

    useEffect(() => {
        let URLParams = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        setSectionLoadingVisible(true)
        if (!props.currentUser)
            return
        getCustomers(props.currentUser.userToken, URLParams).then(res => {
            setSectionLoadingVisible(false)
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setPaginationLinks(resData.links)
                setCustomers(resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_CUSTOMERS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCustomers `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setSectionLoadingVisible(false)
                    setLoading(false)
                }
            })
        })
    }, [keyword, page, props])



    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);

    };

    const handleDelete = (customerId) => {
        const filtersCustomersList = customers.filter(item => item.user_id !== customerId)
        setCustomers(filtersCustomersList)
    }

    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        setSectionLoadingVisible(true)
        if (searchQueryValue && searchQueryValue.length) {
            setSearchQuery(searchQueryValue)
            props.history.push(`/my-sales/customers?keyword=${searchQueryValue}&page=1`)
        }

        if (!searchQueryValue) {
            setSearchQuery("")
            props.history.push(`/my-sales/customers?page=1`)
        }
    }, 500)

    return (
        <section id="app-customers" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-customers">
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">customers</p>
                    </div>

                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <CustomerTableTopBar

                                        column__Customer={column__Customer}
                                        column__Email={column__Email}
                                        column__Type={column__Type}
                                        column__TwoFactors={column__TwoFactors}
                                        column__LastActive={column__LastActive}
                                        column__Status={column__Status}

                                        setColumn__Customer={bool => setColumn__Customer(bool)}
                                        setColumn__Email={bool => setColumn__Email(bool)}
                                        setColumn__Type={bool => setColumn__Type(bool)}
                                        setColumn__TwoFactors={bool => setColumn__TwoFactors(bool)}
                                        setColumn__LastActive={bool => setColumn__LastActive(bool)}
                                        setColumn__Status={bool => setColumn__Status(bool)}

                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                <div className="st-listing-table customers-table">
                                    <CustomerTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}

                                        column__Customer={column__Customer}
                                        column__Email={column__Email}
                                        column__Type={column__Type}
                                        column__TwoFactors={column__TwoFactors}
                                        column__LastActive={column__LastActive}
                                        column__Status={column__Status}
                                        loadingCount={loadingCount}
                                        loading={loading}
                                        customers={customers}
                                        handleDelete={(customerId) => handleDelete(customerId)}
                                    />

                                    {
                                        sectionLoadingVisible && (
                                            <SectionLoading />
                                        )
                                    }

                                </div>
                            </div>

                            {/* paginations */}
                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={"/my-sales/customers"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(Customers)